import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-whitelabel-options-list',
  templateUrl: './whitelabel-options-list.component.html',
  styleUrls: ['./whitelabel-options-list.component.css']
})
export class WhitelabelOptionsListComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
